import createStore from "astrid-helpers/src/createStore";
export const [getRect, setRect, useRect] = createStore({
  top: 0,
  left: 0,
  width: 0,
  height: 0
});
//# sourceMappingURL=rect.js.map